import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { AxiosResponse } from "axios";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";
import { DeleteRoomMaintenanceResponse } from "../response/DeleteRoomMaintenanceResponse";

interface DeleteRoomMaintenanceData {
    id: string;
}

export const useDeleteRoomMaintenance = () => {
    return useMutation({
        mutationKey: ['room-maintenance', 'delete'],
        mutationFn: async (formData: DeleteRoomMaintenanceData) => privateApi.delete(`/v4/room-maintenance/${formData.id}`),
        onSuccess: async (response: AxiosResponse) => {
            const validationResult = DeleteRoomMaintenanceResponse.safeParse(response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid room maintenance data format");
            }

            return validationResult.data;
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid room maintenance data format");
            } else {
                console.error(`Failed to delete room maintenance`, error);
                throw error;
            }
        }
    })
}